import type { ColorScheme } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/types";
import { FC, ReactNode } from "react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { DropsButton, Flex, Text } from "shared/components/Spor";

type CardHeaderProps = {
  title: ReactNode;
  colorScheme: ColorScheme;
  semantics: Semantics;
  notifying: boolean;
  onToggleNotify: () => void;
  showNotifyButton?: boolean;
};

export const CardHeader: FC<CardHeaderProps> = ({
  title,
  colorScheme,
  semantics,
  notifying,
  onToggleNotify,
  showNotifyButton,
}) => (
  /* TODO put back in when muting is global, then only trafikkplanlegger should be able to mute */
  // const isTrafikkplanlegger = useDropsRole((s) => s.isTrafikkplanlegger);
  <Flex justifyContent="space-between" alignItems="center" width="100%">
    <Text
      variant="sm"
      color={colorScheme.textColorMain}
      textAlign="left"
      verticalAlign="center"
      fontWeight="normal"
    >
      {title}
    </Text>

    {/* TODO, only show for vaktleder once global muting is implemented */}
    {showNotifyButton && (
      <DropsButton
        size="xs"
        variant="tertiary"
        semantics={semantics}
        onClick={(e) => {
          e.stopPropagation();
          onToggleNotify();
        }}
        minWidth="fit-content"
        maxHeight="30px"
      >
        {notifying ? "Demp" : "Fremhev"}
      </DropsButton>
    )}
  </Flex>
);
